module.exports = __webpack_public_path__ + "img/2022-4.3c11ef47.jpg";